export const setWellTestDetails = (form) => {
  return {
    type: "SET_WELL_TEST_DETAILS",
    form,
  };
};
export const updateWellTestDetails = (forms) => {
  return {
    type: "UPDATE_WELL_TEST_DETAILS",
    forms,
  };
};
export const incrementSubmittedCount = (count) => {
  return {
    type: "INCREMENT_SUBMITTED_COUNT",
    count,
  };
};

export const resetWellTestState = () => {
  return {
    type: "RESET_WELL_TEST_STATE",
  };
};
